<script lang="ts">
  import { Col, Container, Row } from "sveltestrap";
  import BookmarkImageCropper from "./BookmarkImageCropper.svelte";
  import Card from "../../Core/Card.svelte";
  import { ImageCropper } from "../../../utils/Constant/Constant";
  import Cropper from "svelte-easy-crop";
	import getCroppedImg from "./canvasUtils";

	let crop = { x: 0, y: 0 };
	let zoom = 1;
	let image:any, fileinput:any, pixelCrop:any, croppedImage:any;

	const defaultSrc =
	  "https://cdn1-www.dogtime.com/assets/uploads/2011/03/puppy-development.jpg";

	function onFileSelected(e) {
	  let imageFile = e.target.files[0];
	  let reader = new FileReader();
	  reader.onload = e => {
	    image = e.target.result;
	  };
	  reader.readAsDataURL(imageFile);
	}

	let profilePicture, style;

	function previewCrop(e) {
	  pixelCrop = e.detail.pixels;
	  const { x, y, width } = e.detail.pixels;
	  const scale = 200 / width;
	  profilePicture.style = `margin: ${-y * scale}px 0 0 ${-x *
	    scale}px; width: ${profilePicture.naturalWidth * scale}px;`;
	}

	async function cropImage() {
	  croppedImage = await getCroppedImg(image, pixelCrop);
	}

	function reset() {
	  croppedImage = null;
	  image = null;
	}
</script>
<BookmarkImageCropper />
<Container fluid>
    <Row>
      <Col sm="12">
        <Card cardHeaderprops="pb-0" headerTitle={ImageCropper}>
          <div slot="contentbody">
            <Row>
              <Col xl="9" md="12" class="docs-buttons">
                {#if !image}
                  <input type="file" accept=".jpg, .jpeg, .png" on:change={(e)=>onFileSelected(e)} bind:this={fileinput} >
                  <button type="button" on:click={() => {image = defaultSrc}}>Click me!</button>
                {:else}
                  <div style="position: relative; width: 100%; height: 300px;">
                    <Cropper
                      {image}
                      bind:crop 
                      bind:zoom
                      on:cropcomplete={previewCrop}
                      aspect={1}
                    />
                  </div>
                  <div class="prof-pic-wrapper">
                    <img
                      bind:this={profilePicture}
                      class="prof-pic"
                      src={image}
                      alt="Profile example"
                      {style}
                    />
                  </div>
                  {#if croppedImage}
                    <img
                      src={croppedImage}
                      alt="Cropped profile"
                    /><br>
	                {:else}
                    <br><button type="button" on:click={async () => {croppedImage = await getCroppedImg(image, pixelCrop)}}>Crop!</button>
                  {/if}
	                <button type="button" on:click={reset}>Start over?</button>
                {/if}
              </Col>
            </Row>
          </div>
        </Card>
      </Col>
    </Row>
</Container>